export default "__VITE_ASSET__BYCe7UhP__"